import store from 'utils/store/withMiddleware'

function getValueFromStorage() {
  const hcStorage = store.getState().hcStorage
  const pivotPlan = hcStorage.pivotPlan

  return `${pivotPlan.planId}-${pivotPlan.planName}-${hcStorage.period}-${hcStorage.policies}-${pivotPlan.monthlyCost}`
}

export { getValueFromStorage }
